module.exports = __webpack_public_path__ + "static/iStock-500627852-87a628241ee9b8f7db861d771b75b0da.jpg";